// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Campaign Body */
.KDWtDdkab8dLHU6nufLM {
  position: relative;
  z-index: 1;
  display: flex;
  height: var(--campaign-panel-height, 449px);
  flex-direction: row;
  padding: 0;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: landscape) {
  .KDWtDdkab8dLHU6nufLM[data-one-item='false'] {
    display: flex;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: landscape) {
  .KDWtDdkab8dLHU6nufLM[data-one-item='false'] {
    display: flex;
  }
}
}
}
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .KDWtDdkab8dLHU6nufLM {
    flex-direction: column;
    height: 100%;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .KDWtDdkab8dLHU6nufLM {
    flex-direction: column;
    height: 100%;
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/MultiViewCampaignSection/components/CampaignSectionBody/CampaignSectionBody.modules.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,UAAU;AACZ;AACA;AAAA;EACE;IACE,aAAa;EACf;AACF;AAAA;AAJA;AAAA;AAAA;AAAA;EACE;IACE,aAAa;EACf;AACF;AAAA;AAAA;AAAA;AACA;AAAA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;AACF;AAAA;AALA;AAAA;AAAA;AAAA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;AACF;AAAA;AAAA;AAAA","sourcesContent":["/* Campaign Body */\n.CampaignSectionBody {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  height: var(--campaign-panel-height, 449px);\n  flex-direction: row;\n  padding: 0;\n}\n@media (--campaign-mobile) and (orientation: landscape) {\n  .CampaignSectionBody[data-one-item='false'] {\n    display: flex;\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  .CampaignSectionBody {\n    flex-direction: column;\n    height: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"CampaignSectionBody": `KDWtDdkab8dLHU6nufLM`
};
export default ___CSS_LOADER_EXPORT___;
